import { apiRequest } from "../lib/apiClient";
import type { BranchCreate, BranchOut, BranchUpdate } from "./types";

/** `GET /branches` — any authenticated role (needed to populate a picker regardless of
 * the caller's own role); write access (`create`/`update` below) is `OWNER`-only,
 * enforced by the backend and mirrored in `roles/permissions.ts`. */
export async function listBranches(accessToken: string): Promise<BranchOut[]> {
  return apiRequest<BranchOut[]>("/branches", { accessToken });
}

export async function createBranch(accessToken: string, body: BranchCreate): Promise<BranchOut> {
  return apiRequest<BranchOut>("/branches", { method: "POST", accessToken, body });
}

export async function updateBranch(accessToken: string, branchId: string, body: BranchUpdate): Promise<BranchOut> {
  return apiRequest<BranchOut>(`/branches/${branchId}`, { method: "PATCH", accessToken, body });
}
